/**
 * @CustomPagination
 * enables customizable pagination
 * add your own HTML
 * this extension only adds necessary listeners
 */
export function CustomPagination(Splide, Components, options) {
    const customPaginationElement = Splide.root?.querySelector('.splide__custom-pagination');

    const customPaginationPageElements = [
        ...(customPaginationElement?.querySelectorAll('.splide__custom-pagination-page') || []),
    ];

    const slides = Splide.Components.Slides.get();

    function mount() {
        // TODO: document this option
        if (options.customPagination) {
            customPaginationPageElements
                .find((el) => Number(el.dataset.page) === Splide.index)
                ?.classList.add('is-active');

            customPaginationPageElements.forEach((el) => {
                el.addEventListener('click', () => {
                    Splide.go(Number(el.dataset.page));
                    customPaginationPageElements.forEach((ell) =>
                        ell.classList.remove('is-active')
                    );
                    el.classList.add('is-active');
                });
            });

            Splide.on('active', () => {
                setTimeout(() => {
                    const prevSlide = slides.find((el) => el.slide.classList.contains('is-prev'));
                    const nextSlide = slides.find((el) => el.slide.classList.contains('is-next'));

                    customPaginationPageElements.forEach((el) =>
                        el.classList.remove('is-prev', 'is-next')
                    );

                    if (prevSlide) {
                        customPaginationPageElements
                            .find((el) => Number(el.dataset.page) === prevSlide.index)
                            ?.classList.add('is-prev');
                    }

                    if (nextSlide) {
                        customPaginationPageElements
                            .find((el) => Number(el.dataset.page) === nextSlide.index)
                            ?.classList.add('is-next');
                    }
                }, 0);
            });
        }
    }

    return { mount };
}
